import api from '../api'

export const postProject = (params) => api.post('/companies/projects', params)

export const putProject = ({ id, ...params }) => api.put(`/companies/projects/${ id }`, params)

export const patchProject = ({ id }) => api.patch(`/companies/projects/${ id }`)
